import styled, { keyframes } from 'styled-components/macro';

import { large } from 'styles/breakpoints';
import { container } from 'styles/layout';
import { eyebrowThin, paragraph } from 'styles/typography';
import { IWithThemeProps } from 'typings';

interface ISelectBoxContainerProps {
  isSuccessful: boolean;
}

interface ITextBoxContainerProps {
  isSuccessful: boolean;
  isVisible: boolean;
}

export const ContainerBottom = styled.div`
  ${container}

  margin-top: 40px;
  padding-right: 6px;

  ${large`
    padding-right: 0;
  `}
`;

export const SelectBoxContainer = styled.div<ISelectBoxContainerProps>`
  opacity: 0;
  position: relative;
  transition-property: opacity;
  transition-timing-function: ease;
  z-index: 2;

  ${({ theme }: IWithThemeProps) => `
    background: ${theme.bottomBackgroundColor};
    transition-duration: ${theme.transitionDurationCarouselTrack};
  `}

  ${({ isSuccessful }) => `
    opacity: ${isSuccessful ? 0 : 1};
  `}
`;

export const TextBoxContainer = styled.div<ITextBoxContainerProps>`
  margin: -43px auto -12px;
  opacity: 0;
  overflow: hidden;
  transition-property: margin-top, opacity;
  transition-timing-function: ease;

  ${({ theme }: IWithThemeProps) => `
    transition-duration: ${theme.transitionDurationCarouselTrack};
  `}

  ${({ isSuccessful, isVisible }) => {
    if (isSuccessful) {
      return `
        margin-top: -68px;
      `;
    } else if (isVisible) {
      return `
        margin-top: 16px;
        opacity: 1;
      `;
    }

    return '';
  }}
`;

const fadeIn = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

export const SuccessMessage = styled.div`
  animation-fill-mode: forwards;
  animation-name: ${fadeIn};
  animation-timing-function: ease;
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 28px;
  z-index: 2;

  ${({ theme }: IWithThemeProps) => `
    animation-duration: ${theme.transitionDurationPrimary};
  `}
`;

export const SuccessMessageHeader = styled.p`
  ${eyebrowThin}

  margin: 0 0 4px;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.bottomForegroundPrimary};
  `}
`;

export const SuccessMessageBody = styled.p`
  ${paragraph}

  margin: 0;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.bottomForegroundPrimary};
  `}
`;
